import {
  Typography,
  // CardMedia,
  Button,
  Grid,
  IconButton,
  Stack,
  Box
} from '@mui/material';
import { motion } from 'framer-motion';
// import pfp from '../assets/images/pfp1.jpeg';
import locationIcon from '../assets/icons/location.png';
import linkedInIcon from '../assets/icons/linkedin.png';
import githubIcon from '../assets/icons/github.png';
import gmailIcon from '../assets/icons/gmail.webp';
import { ModeToggleButton } from './ModeToggleButton';
import useVisibilityOnScroll from '../hooks/useVisibilityOnScroll';

const RESUME_URL = '/taglinao-resume-2026.pdf';
const LINKEDIN_URL = "https://www.linkedin.com/in/ariannetaglinao/";
const GITHUB_URL = "https://github.com/leearianne";
const EMAIL_ADDRESS = "ariannetaglinao@gmail.com"

const LINKS = [
  { icon: githubIcon, url: GITHUB_URL, alt: "Github Icon" },
  { icon: gmailIcon, url: `mailto:${EMAIL_ADDRESS}`, alt: "Gmail Icon" },
  { icon: linkedInIcon, url: LINKEDIN_URL, alt: "LinkedIn Icon" },
]

const MotionBox = motion(Box);

const Header = () => {
  const [headerRef, isHeaderVisible] = useVisibilityOnScroll(0.2, true);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.4, 0, 0.2, 1] as any
      }
    }
  };

  return (
    <MotionBox
      ref={headerRef}
      variants={containerVariants}
      initial="hidden"
      animate={isHeaderVisible ? "visible" : "hidden"}
      sx={{ my: 3 }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={3}
      >
        <Grid
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <MotionBox
            variants={itemVariants}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <Box>
              <Typography
                variant='h2'
                sx={{
                  mb: 0.5,
                  background: (theme) => theme.palette.mode === 'dark'
                    ? 'linear-gradient(135deg, #f8fafc 0%, #94a3b8 100%)'
                    : 'linear-gradient(135deg, #1a1a1a 0%, #374151 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                Lee Arianne Taglinao
              </Typography>
              <Typography
                variant='body1'
                sx={{
                  color: 'text.secondary',
                  fontWeight: 500,
                }}
              >
                Full Stack Developer
              </Typography>
            </Box>

            <ModeToggleButton />
          </MotionBox>

          <MotionBox
            variants={itemVariants}
            sx={{ display: "flex" }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <img src={locationIcon} alt="Location Icon" style={{ width: 16, height: 16 }} />
              <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                Makati City, Philippines
              </Typography>
            </Stack>
          </MotionBox>

          <MotionBox
            variants={itemVariants}
            sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}
          >
            <a href={RESUME_URL} download="taglinao-resume" target='_blank' rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <Button
                variant="outlined"
                sx={{
                  borderColor: 'secondary.main',
                  color: 'secondary.main',
                  fontSize: '13px',
                  fontWeight: 600,
                  px: 2.5,
                  py: 1,
                  '&:hover': {
                    borderColor: 'secondary.lighter',
                    backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(59, 130, 246, 0.1)' : 'rgba(37, 99, 235, 0.05)',
                  }
                }}
              >
                Download Resume
              </Button>
            </a>
            {LINKS.map((link, index) => (
              <motion.div
                key={link.alt}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.6 + index * 0.1, duration: 0.3 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <IconButton
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    width: 42,
                    height: 42,
                  }}
                >
                  <img src={link.icon} alt={link.alt} style={{ width: 20, height: 20 }} />
                </IconButton>
              </motion.div>
            ))}
          </MotionBox>
        </Grid>
      </Stack>
    </MotionBox>
  );
}

export default Header;